import { ListItemButton, ListItemText } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import Link from 'next/link'

const useStyles = makeStyles((theme) => ({
  listItem: {
    paddingLeft: theme.spacing(5)
  },
  listItemSelected: {
    backgroundColor: 'transparent !important',
    '&::before': {
      content: '"\\e5ca"',
      fontFamily: 'Material Icons',
      fontWeight: 'bold',
      display: 'block',
      position: 'absolute',
      left: theme.spacing(2)
    },
    fontWeight: 500
  }
}))

export default function FilterItem ({ name, href, selected, handleClick }) {
  const classes = useStyles()

  return (
    (
      <Link href={href} passHref legacyBehavior>
        <ListItemButton selected={selected} classes={{ root: classes.listItem, selected: classes.listItemSelected }} onClick={handleClick}>
          <ListItemText primary={name} disableTypography />
        </ListItemButton>
      </Link>
    )
  )
}
